import { useRef, useState } from 'react';

let globalSelectCounter = 0;

function getInnerSelectInstance(ref) {
  if (!ref.current) return null;
  // ref.current = StateManager instance
  // ref.current.select = inner Select (regular) OR Creatable (creatable)
  // ref.current.select.select = inner Select (creatable only)
  const inner = ref.current.select;
  if (!inner) return null;
  return inner.select || inner;
}

export default function useSelectCustomizable({ inputId, name }) {
  const instanceIdRef = useRef(`select-accessible-${++globalSelectCounter}`);
  const resolvedInputId = inputId || name || instanceIdRef.current;
  const labelId = `${resolvedInputId}-label`;
  const listboxId = `${resolvedInputId}-listbox`;

  const selectRef = useRef(null);
  const menuIsOpenRef = useRef(false);
  const [focusedOptionId, setFocusedOptionId] = useState(null);

  function handleKeyDown(event) {
    if (event.key === 'Enter' && !menuIsOpenRef.current) {
      event.preventDefault();
      const instance = getInnerSelectInstance(selectRef);
      if (instance && typeof instance.openMenu === 'function') {
        instance.openMenu('first');
      }
    }
  }

  function handleMenuOpen() {
    menuIsOpenRef.current = true;
  }

  function handleMenuClose() {
    menuIsOpenRef.current = false;
    setFocusedOptionId(null);
  }

  function onOptionFocusChange(id) {
    setFocusedOptionId(id || null);
  }

  return {
    resolvedInputId,
    labelId,
    listboxId,
    selectRef,
    focusedOptionId,
    onOptionFocusChange,
    handleKeyDown,
    handleMenuOpen,
    handleMenuClose,
  };
}
